import { render, staticRenderFns } from "./SubmissionFail.vue?vue&type=template&id=650d1e33&scoped=true&"
import script from "./SubmissionFail.vue?vue&type=script&lang=js&"
export * from "./SubmissionFail.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionFail.vue?vue&type=style&index=0&id=650d1e33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650d1e33",
  null
  
)

export default component.exports